'use strict';

// Simple helper functions
// none of these need any external deps

module.exports = function identity(d) { return d; };
